import { UserCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const AvatarScratch = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <UserCircleIcon color={fill || stroke} weight="regular" {...rest} size={Sizes[size]} />;
};

AvatarScratch.displayName = 'AvatarScratch';
